import { Box, Chip, FormHelperText, Typography } from '@mui/material';
import * as colors from '@mui/material/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FireIcon from '../FireIcon';
import MedicalIcon from '../MedicalIcon';
import PanicIcon from '../PanicIcon';
import { CONTACT_REASONS_TYPE } from './reasonsColorIcon';
import ViolationIcon from '../ViolationIcon';

export type ContactReasonItemType = {
  id: number;
  enabled: boolean;
};

export type ContactReasons = {
  fire: ContactReasonItemType;
  violation: ContactReasonItemType;
  medical: ContactReasonItemType;
  panic: ContactReasonItemType;
};

type Reason = keyof ContactReasons;

function ContactReasonField({
  value,
  error,
  helperText,
  selectItem,
}: {
  value: ContactReasons;
  error?: boolean;
  helperText?: React.ReactNode;
  selectItem: (item: Reason, enabled: boolean) => void;
}) {
  const { t } = useTranslation(['_common', 'contacts']);

  const items = React.useMemo(
    () => (value ? (Object.keys(value).filter((item) => item !== '__typename') as Reason[]) : []),
    [value],
  );

  const icons = {
    fire: <FireIcon />,
    violation: <ViolationIcon />,
    medical: <MedicalIcon />,
    panic: <PanicIcon />,
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {t('contacts:call_this_contact_in_case_of')}
      </Typography>
      {items.map((item) => {
        return (
          // eslint-disable-next-line no-console
          <ContactReasonItem
            key={value[item].id}
            color={value[item].enabled ? CONTACT_REASONS_TYPE[item].color : 'grey'}
            icon={icons[item]}
            label={t(`_common:${item}`)}
            onClick={() => selectItem(item, !value[item].enabled)}
          />
        );
      })}
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
}

function ContactReasonItem({
  color,
  label,
  icon,
  onClick,
}: {
  color: string;
  label: string;
  icon: React.ReactElement;
  onClick: () => void;
}) {
  return (
    <Chip
      {...{ onClick, icon, label }}
      sx={{
        mr: 1,
        /* @ts-ignore */
        color: colors[color][700],
        /* @ts-ignore */
        bgcolor: colors[color][50],
        '.MuiChip-icon': {
          /* @ts-ignore */
          color: colors[color][700],
        },
      }}
    />
  );
}

export default ContactReasonField;
